'use client';

import { c as _c } from "react/compiler-runtime";
import { type Choice, ChoiceList, Heading } from '@jaaq/hub-ui';
import { Sparkles, Zap } from 'lucide-react';
import type { ReactElement } from 'react';
import { OnboardingShell } from '#components/onboarding-shell';
import { useOnboardingState } from '#lib/onboarding-provider';
import type { HostedTier } from '#lib/steps/state';
const CHOICES: Choice<HostedTier>[] = [{
  id: 'standard',
  title: 'Out the Box — Ready to Go',
  description: 'Standard library with our branding, quick to deploy',
  icon: <Zap className="size-6" />
}, {
  id: 'custom',
  title: 'Custom Branding — Bespoke Filming',
  description: 'Exclusive content tailored to your company',
  icon: <Sparkles className="size-6" />
}];
export const HostedTierStep = () => {
  const $ = _c(11);
  const {
    onboardingState,
    patch,
    goNext
  } = useOnboardingState();
  const t0 = Boolean(onboardingState.hostedTier);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      index: 2,
      total: 2
    };
    t2 = <Heading level={1} variant="display" tone="inverse">Choose your Hosted tier</Heading>;
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  let t3;
  if ($[2] !== patch) {
    t3 = id => patch({
      hostedTier: id
    });
    $[2] = patch;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onboardingState.hostedTier || $[5] !== t3) {
    t4 = <ChoiceList choices={CHOICES} selection={{
      selectedId: onboardingState.hostedTier,
      onSelect: t3
    }} />;
    $[4] = onboardingState.hostedTier;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== goNext || $[8] !== t0 || $[9] !== t4) {
    t5 = <OnboardingShell canContinue={t0} onContinue={goNext} customProgress={t1}>{t2}{t4}</OnboardingShell>;
    $[7] = goNext;
    $[8] = t0;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};